import React from "react";
import { Alert, Button, Checkbox, Form, Icon, Input, message } from "antd";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { userSignIn, resetSignInError } from "../appRedux/actions/Auth";
import InfoView from "components/InfoView";
import MaintenanceBanner from "../components/common/MaintenanceBanner";

const FormItem = Form.Item;

class SignIn extends React.Component {
  state = {
    loading: false,
    showPassword: false,
  }

  componentDidMount() {
    if (this.props.authenticated) {
      this.props.history.replace({ pathname: '/' });
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (values.remember) {
          if (!this.state.loading) {
            this.setState({ loading: true });
            this.props.userSignIn(values.email, window.btoa(values.password));
            setTimeout(() => {
              this.setState({ loading: false });
            }, 3000);
          }
        } else {
          message.error({ content: 'Please accept terms and conditions to sign in!', key: 'signin-error' });
        }
      }
    });
  };

  handleOnClose = () => {
    this.props.resetSignInError();
  }

  togglePasswordVisibility = () => {
    this.setState(({ showPassword }) => ({ showPassword: !showPassword }));
  }

  render() {
    const { message } = this.props;
    const { loading, showPassword } = this.state;
    const { getFieldDecorator } = this.props.form;

    return (
      <div className="clarity-signin-page">
        <MaintenanceBanner className="clarity-signin-maintenance" />

        <main className="clarity-signin-layout">
          <section className="clarity-signin-visual" aria-hidden="true">
            <img src={`${process.env.PUBLIC_URL}/clarity_login.png`} alt="" />
          </section>

          <section className="clarity-signin-panel">
            <div className="clarity-signin-card">
              <header className="clarity-signin-brand">
                <img src={require("assets/images/clarity-logo.png")} alt="Clarity" />
                <p>RadiScan</p>
              </header>

              <Form onSubmit={this.handleSubmit} layout="vertical" className="clarity-signin-form">
                <FormItem label="Email">
                  {getFieldDecorator('email', {
                    initialValue: "",
                    rules: [{ required: true, message: 'Please input your Email!' }],
                  })(
                    <Input
                      autoComplete="username"
                      placeholder="Enter your email"
                      prefix={<Icon type="mail" />}
                    />
                  )}
                </FormItem>

                <div className="clarity-password-heading">
                  <label htmlFor="password">Password</label>
                  <Link to="/forgot-password">Forgot Password?</Link>
                </div>
                <FormItem>
                  {getFieldDecorator('password', {
                    initialValue: "",
                    rules: [{ required: true, message: 'Please input your Password!' }],
                  })(
                    <Input
                      id="password"
                      autoComplete="current-password"
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter your password"
                      prefix={<Icon type="lock" />}
                      suffix={
                        <button
                          type="button"
                          className="clarity-password-toggle"
                          onClick={this.togglePasswordVisibility}
                          aria-label={showPassword ? "Hide password" : "Show password"}
                        >
                          <Icon type={showPassword ? "eye" : "eye-invisible"} />
                        </button>
                      }
                    />
                  )}
                </FormItem>

                {message !== "" &&
                  <Alert message={message} type="error" showIcon closable onClose={this.handleOnClose} />
                }

                <FormItem className="clarity-submit-item">
                  <Button type="primary" htmlType="submit" loading={loading}>
                    Sign In
                  </Button>
                </FormItem>

                <FormItem className="clarity-terms-item">
                  {getFieldDecorator('remember', {
                    valuePropName: 'checked',
                    initialValue: true,
                    rules: [{ required: true }],
                  })(
                    <Checkbox>
                      By clicking you Agree to <Link to="/terms" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</Link>
                    </Checkbox>
                  )}
                </FormItem>
              </Form>

              <footer className="clarity-signin-footer">&copy;Clarity 2026</footer>
            </div>
            <InfoView />
          </section>
        </main>
      </div>
    );
  }
}

const WrappedNormalLoginForm = Form.create()(SignIn);

const mapStateToProps = ({ auth }) => {
  const { authUser, message } = auth;
  return { authenticated: authUser ? authUser.authenticated : false, message }
};

export default connect(mapStateToProps, { userSignIn, resetSignInError })(WrappedNormalLoginForm);
